export const teamsLinkUrl =
  "https://teams.microsoft.com/l/team/" +
  "19%3A7b5db0f67ce24410a1ce1e268167ec43%40thread.tacv2/conversations?" +
  "groupId=0ee44bea-48eb-4d64-9847-81fd34e494f3&" +
  "tenantId=631f985f-427e-4921-a153-c467ec975fb6";
export const efsSurveyUrl = "https://www.efs-survey.com/uc/tesa_leap2021/?a=2&b=";
